import { render, staticRenderFns } from "./cell-ledger-amount.vue?vue&type=template&id=3f4478f0&scoped=true"
import script from "./cell-ledger-amount.ts?vue&type=script&lang=ts&external"
export * from "./cell-ledger-amount.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-ledger-amount.vue?vue&type=style&index=0&id=3f4478f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4478f0",
  null
  
)

export default component.exports